import React, { useContext, useEffect, useRef, useState, useMemo } from "react";
import MaterialTable from "material-table";
import { tableIcons } from "../../users/components/TableIcons";
import LocationIcon from '@material-ui/icons/LocationOn';
import { SnackbarContent } from "../../../styled-components/shared";
import { Snackbar, createTheme, CircularProgress, Tooltip } from "@material-ui/core";
import app from "../../../authentication/firebaseStart";
import { firebaseObj } from "../../../authentication/firebaseStart";
import { AuthContext } from "../../../authentication/Auth";
import Pagination from "../../users/components/Pagination";
import DevicesToolbar from "./Components/DevicesToolbar";
import { summaryConfig } from "../../../data/dashboardConfig";
import { useHistory } from "react-router";
import DropdownActions from "../../../components/DropdownSimple";
import ActionDropDown from "../../../components/ActionDropDown";
import ConfirmationModal from "../../../components/modals/ConfirmationModal";
import styled from "styled-components";
import AddNoteModal from "../../../components/modals/AddNoteModal";
import firebaseUtil from "../../../data/FirebaseUtil";
import { useTranslation } from "react-i18next";
import SummaryCountServices from '../../../Services/SummaryCountServices';
import DevicesManageAMDModal from "../../../components/modals/DevicesManageAMDModal";
import CsvCompModal from "../../../components/modals/CsvCompModal";
import AddDevicesPopUp from "../../../components/modals/AddDevicesPopUp";
import ModifyDevicesPopUp from "../../../components/modals/ModifyDevicesPopUp";
import Checkbox from '@material-ui/core/Checkbox';
import { DevicesConfigData } from '../../../components/CSVCompConfig';
import { DataContext } from '../../../data/DataContext';
import { DLR_MACHINE_LEARNING } from "../../../data/constants";
import { launchMap } from "../../../data/gpsUtil";
import RearrangeDashBoardColumnModel from "../../../components/modals/Preferences/RearrangeDashBoardColumnModel";
import { Button } from "@material-ui/core";
import ViewWeekIcon from '@material-ui/icons/ViewWeek';
import {convertUtcToTimeZone ,getTimeAgo} from "../../../data/dateTimeUtil"
import { COL_PREFERENCES } from "../../../data/constants";
import FilterMenu from "../../../components/modals/Preferences/FilterMenu";
import FilterListIcon from '@material-ui/icons/FilterList';
import { FILTER_CONSTANT } from '../../../data/constants';
import  TooltipMat  from '../../../components/TooltipMat';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import './device.css'
import { userJustManager } from "../../../data/userUtil";
import { DEVICELIST_CONSTANT } from "../../../data/constants"; 
const filterItems = [
  {
    header: "Device Model",
    dbKey: "modelNumber",
    options: [],
    totalOptions: 0,
    isDBDependent: true
  },
  {
    header: "Status",
    dbKey: "deviceState",
    options: [
      {
        value: 0,
        label: "In Service"
      },
      {
        value: 1,
        label: "To Be found"
      },
      {
        value: 2,
        label: "Being Found"
      },
      {
        value: 3,
        label: "Found"
      },
      {
        value: 4,
        label: "Cannot Find"
      },
      {
        value: 9999,
        label: "Decommissioned"
      }
    ],
    totalOptions: 6,
    isDBDependent: false
  },
  {
    header: "Connection",
    dbKey: "connectionState",
    options: [
      {
        value: 0,
        label: "Never Connected"
      },
      {
        value: 1,
        label: "Connected"
      },
      {
        value: 2,
        label: "Disconnected"
      },
    ],
    totalOptions: 3,
    isDBDependent: false
  },
  {
    header: "Charging",
    dbKey: "isCharging",
    options: [
      {
        value: 0,   // convert to Boolean
        label: "Not Charging"
      },
      {
        value: 1,   // convert to Boolean
        label: "Charging"
      }
    ],
    totalOptions: 2,
    isDBDependent: false
  },
  {
    header: "Sites",
    dbKey: "siteName",
    options: [],
    totalOptions: 0,
    isDBDependent: true
  },
  {
    header: "Misc.",
    dbKey: "misc",
    options: [
      {
        label: "Checked Out",
        value: "checkOutState"
      },
      {
        label: "Low Battery",
        value: "lowBattery"
      },
      {
        label: "Idle",
        value: "isIdle"
      },
    ],
    totalOptions: 3,
    isDBDependent: false,
    isRadio: true
  }
]

const config = require("../../../../src/data/application.properties");

const firestore = app.firestore();

const theme = createTheme({
  palette: {
    primary: {
      main: "#007ABA",
    },
    secondary: {
      main: "#007ABA",
    },
  },
});

// const theme = createMuiTheme({
//   palette: {
//     primary: {
//       main: "#007ABA",
//     },
//     secondary: {
//       main: "#007ABA",
//     },
//   },
// });

const CuzCell = styled.p`
  overflow: hidden;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
`;

const PageWrapper = styled.div`
  background: white;
  box-shadow: 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%),
    0 1px 3px 0 rgb(0 0 0 / 20%);
  padding: 20px;
`;

const MainContent = styled.div`
  // border-top: 2px solid #e1e1e1;
  borer-bottom: none;
  border: 1px solid #bdbdbd;
  margin-top: 10px;
  @media screen and (max-width: 750px) {
    margin-top: 60px;
  }
`;
const deviseTableMap = {
  displayDeviceFriendlyName: 'friendlyName',
}

var allDevData = [];

function getDeviceStateListFromConfig() {
  const filterConfigObject = summaryConfig[0].mobile.filterName;
  const desiredObj = {};
  Object.keys(filterConfigObject).forEach((item) => {
    if (
      filterConfigObject[item]?.deviceState != null ||
      filterConfigObject[item]?.deviceState !== undefined
    ) {
      desiredObj[filterConfigObject[item]?.deviceState] = item;
      return;
    }
  });
  return desiredObj;
}

var allDevData = [];

export default function DevicesListDashboard(props) {
  
  let sessionColumnsData =JSON.parse(sessionStorage.getItem("dashboardColumn"));
  let savedColumnsData = sessionColumnsData ? sessionColumnsData[COL_PREFERENCES.DEVICE_DASHBOARD.DB_NAME] : [];
  const deviceStateList = useMemo(() => getDeviceStateListFromConfig(), []);
  const actionsToCode = useMemo(() => summaryConfig[1].actionsToCode, []);
  const context = useContext(AuthContext);
  // DLR flag
  const { dlrFeatureFlag, mlPredictionStatus } = useContext(DataContext);
  const [showDLR, setShowDLR] = useState(false);
  const companyID = context.currentUser.claims.companyID;
  const isManager = userJustManager(context.currentUser.claims);
  const DEFAULT_ROWS_PER_PAGE = config.ROW_ITEMS_PER_PAGE;
  const [pageSize, setPageSize] = useState(DEFAULT_ROWS_PER_PAGE);
  const [hidePagination, setHidePagination] = useState(false);
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [itemCount, setItemCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [selectedData, setSelectedData] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const serverResponse = useRef("");
  const { t } = useTranslation();
  const addUserModalRef = useRef();
  const DevicesManageAMDModalRef = useRef();
  const CsvCompModalRef = useRef();
  const AddDevicesModalRef = useRef();

  const history = useHistory();
  const { location } = props?.historyObject;
  const [clearNote, setClearNote] = useState(false)
  const [note, setNote] = useState("")
  const { sitevalue } = props;
  const { state } = location;
  const [tempState, setTempState] = useState(null);
  const [searchFromDb, setsearchFromDb] = useState(false);
  const [dbSeacrh, setdbSeacrh] = useState(['', ''])
  const [dataCount, setdataCount] = useState([]);
  const [manageBtnValue, setManageBtnValue] = useState({})
  const [enableModDelete, setEnableModDelete] = useState(false)
  let { globalAppSettings } = useContext(DataContext);
  const isGpsEnabled  = globalAppSettings?.enableGPSLocation;
  // const [isBTTrackingEnabled, setBTScannerTracking]  = useState(globalAppSettings?.enableBTScannerTracking)
  const [confirmPopData, setconfirmPopData] = useState([]);
  const confirmationModalRef = useRef();
  const ModifyDevicesModalRef = useRef();
  const [_ds, onRwoSelected] = useState(true)
  const [sitesData, setSitesData] = useState([])
  const [devicesData, setDevicesData] = useState([])
  const [hasUpdatedTime, setHasUpdatedTime] = useState(false)
  const [isLoadingCsv, setIsLoadingCsv] = useState(false)
  const [checkedoutAtCol,setCheckedoutAtCol] = useState(globalAppSettings?.checkin);
  // const [gpsLocationCollectionEnabled, setGpsLocationCollectionEnabled]  = useState(globalAppSettings?.enableGPSLocation);
  const [columnPreferenceOpen , setColumnPreferenceOpen] = useState(false);
  const [columnsData , setColumnsData] = useState(savedColumnsData);
  const [excludeColumnArray, setExcludeColumnArray] = useState([])
  // filters
  const sortAndFilterFlag = globalAppSettings?.featureToggling?.sortAndFilter == 1 ? true : false;
  const [openFilterMenu, setOpenFilterMenu] = useState(false);
  const [appliedFilterCount, setAppliedFilterCount] = useState(0);
  const [appliedFilter, setAppliedFilter] = useState({});
  const [excludeFilterItems, setExcludeFilterItems] = useState([]);
  const [updateSelectedFilter, setUpdateSelectedFilter] = useState({});
  const [filterAppliedStatus, setFilterAppliedStatus] = useState(0);
  const filterAnchorRef = React.useRef(null);
  // sort
  const [disableSorting, setDisableSorting] = useState(true);
  const [sortingData, setSortingData] = useState([]);

  useEffect(() => {
    if(!dlrFeatureFlag){
      // hiding At Risk if dlr feature is disabled
      setShowDLR(false);
    }
    else{
      if(mlPredictionStatus)  setShowDLR(true);     // showing At Risk if ml prediction enabled
      else  setShowDLR(false);                      // hiding At Risk if ml prediction disabled

      setShowDLR(false);        // comment once decided to to fixed on enrolment column
    }
  }, [mlPredictionStatus, dlrFeatureFlag]);

  useEffect(() => {
    let tempExcluded = [...excludeColumnArray]
    if(!isGpsEnabled){
      if(tempExcluded.indexOf("gpsLocation") == -1)
        tempExcluded = [...tempExcluded, "gpsLocation"]
    }
    else{
      tempExcluded.splice("gpsLocation", 1)
    }

    if(!checkedoutAtCol){
      if(tempExcluded.indexOf("checkedInAt") == -1)
        tempExcluded = [...tempExcluded, "checkedInAt", "checkedOutAt"]
    }
    else{
      tempExcluded.splice("checkedInAt", 1)
      tempExcluded.splice("checkedOutAt", 1)
    }

    if(!showDLR){
      if(tempExcluded.indexOf("enrolmentStatus") == -1)
        tempExcluded = [...tempExcluded, "enrolmentStatus", "enrolmentDate", "zdsStatus"]
    }
    else{
      tempExcluded.splice("enrolmentStatus", 1)
      tempExcluded.splice("enrolmentDate", 1)
      tempExcluded.splice("zdsStatus", 1)
    }

    if(!globalAppSettings?.enableBTScannerTracking){
      if(tempExcluded.indexOf("accessory") == -1)
        tempExcluded = [...tempExcluded, "accessory"]
    }else{
      tempExcluded = tempExcluded.filter(e => e !== 'accessory')
    }
    setExcludeColumnArray([...tempExcluded])
  }, [isGpsEnabled, checkedoutAtCol, dlrFeatureFlag, globalAppSettings]);

  useEffect(() => {
    setdataCount([])
    getTitleData()
    unselectAll()
  }, [sitevalue, location?.state?.deviceSearchObject?.filter]);


  useEffect(() => {
    console.log("isManager ", isManager);
    console.log("isFilterApplied site changed", filterAppliedStatus);
    if(filterAppliedStatus == 2){
      if(sitevalue != "All Devices" && !isManager){
        setUpdateSelectedFilter({ siteName: [sitevalue] });
      }
      else{
        setUpdateSelectedFilter({...appliedFilter, siteName: []});
      }
    }
    setFilterAppliedStatus(2);
    console.log("sitevalue updateSelectedFilter ", sitevalue)
  },[sitevalue]);

  useEffect(() => {
    let filterKeys = [...excludeFilterItems];
    if(isManager || sitevalue != "All Devices"){
      filterKeys.push("siteName");
    }
    else{
      let index = filterKeys.indexOf("siteName");
      if(index > -1){
        filterKeys.splice(index, 1);
      }
    }
    setExcludeFilterItems([...filterKeys]);
  },[isManager]);

  useEffect(() => {
    console.log("isFilterApplied tile changed ", filterAppliedStatus);
    if(state?.deviceSearchObject?.dbKey && state?.deviceSearchObject?.dbKey != "totalTracked" && filterAppliedStatus == 2){
      const { _key, _value, lowBatteryArr } = getKeyAndValueFromConfigFile('', state.deviceSearchObject.dbKey);
      let currentFilter = {};
      console.log("event_value ", _key, _value, lowBatteryArr)
      if(typeof _key == typeof undefined && typeof _value == typeof undefined && lowBatteryArr && lowBatteryArr.length){
        currentFilter["misc"] = ["lowBattery"];
      }
      else if(_key == "checkOutState" || _key == "isIdle"){
        currentFilter["misc"] = [_key];
      }
      else if(typeof _value == "boolean"){
        if(_value)    currentFilter[_key] = [1];
        else    currentFilter[_key] = [0];
      }
      else  currentFilter[_key] = [_value];
      if(updateSelectedFilter.siteName && updateSelectedFilter.siteName.length && appliedFilter.siteName && appliedFilter.siteName.length){
        currentFilter["siteName"] = updateSelectedFilter.siteName;
      }
      setUpdateSelectedFilter(currentFilter)
    }
    else if(state?.deviceSearchObject?.dbKey && state?.deviceSearchObject?.dbKey == "totalTracked" && filterAppliedStatus == 2){
      if("siteName" in appliedFilter && appliedFilter.siteName.length == 1){
        setUpdateSelectedFilter({...appliedFilter,modelNumber: [], deviceState: [], connectionState: [], isCharging: [], misc: []});
      }
      else setUpdateSelectedFilter({ });
    }
    setFilterAppliedStatus(2);

    console.log("selectedTitle tempState ", state);
  }, [state]);

  useEffect(() => {
    console.log(appliedFilter);
    getData(pageSize);
  }, [appliedFilter, sortingData])

  const getTitleData = () => {

    /*SummaryCountServices.getAll(sitevalue, companyID).once("value", (snapshot) => {
      onDataChange(snapshot.val());
      setlastUpdated(Date.now())
    });*/

    firebaseUtil.getDeviceCountAxios({"siteName": sitevalue}).then(response => {
      console.log("Got Summary Summary",response);
      onDataChange( response.data);
      setlastUpdated(Date.now())
    }).catch(error => {
        console.log("getSummaryData Error: " + JSON.stringify(error))

    })

  }

  useEffect(() => {
    if (localStorage) {
      localStorage.removeItem("firebase:previous_websocket_failure");
    }
    if(sessionStorage.getItem("dashboardFilter") != null){
      setFilterAppliedStatus(1);
    }
  }, [])



  useEffect(() => {
    getData(pageSize)
  }, [pageSize])


  let onDataChange = (items) => {
    // SummaryCountServices.getAll().off("value", (snapshot) => { onDataChange(snapshot.val());  });

    let summaryConfigArray = summaryConfig;
    let totaltrackedObj = {
      "dbKey": "totalTracked",
      "color": "#000000",
      "countColor": "#FFFFFF",
      "title": "Total",
      "filter": "totalTracked"
    }
    let summayCofigObject = summaryConfigArray[0].mobile.summaryDashboard;

    summayCofigObject["totalTracked"] = totaltrackedObj;

    const finalArray = [];
    const summayCofigObjectKeys = Object.keys(summayCofigObject)
    summayCofigObjectKeys.forEach((GH) => {
      if (items === null || items === undefined) {
        if (summayCofigObject[GH].filter === 'totalTracked') {
          finalArray.unshift({ ...summayCofigObject[GH], sumCount: 0 });
          return;
        }
        finalArray.push({ ...summayCofigObject[GH], sumCount: 0 })
      } else if (items[GH] != null) {
        if (summayCofigObject[GH].filter === 'totalTracked') {
          let sumCountIs = "" + items[GH];
          // setCountLength(sumCountIs.length);
          finalArray.unshift({ ...summayCofigObject[GH], sumCount: items[GH] });
          return;
        }
        finalArray.push({ ...summayCofigObject[GH], sumCount: items[GH] })
      } else {
        if (summayCofigObject[GH].filter === 'totalTracked') {
          let sumCountIs = "" + items[GH];
          // setCountLength(sumCountIs.length);
          finalArray.unshift({ ...summayCofigObject[GH], sumCount: 0 });
          return;
        }
        finalArray.push({ ...summayCofigObject[GH], sumCount: 0 })
      }
    })


    setdataCount([...finalArray]);



  }


  useEffect(() => {
    getData(pageSize, location);
  }, [dataCount])




  const [lastUpdated, setlastUpdated] = useState('')

  const getFormatedDate = (e) => {
    if (!e) return

    const argDate = new Date(e)
    const year = argDate.getFullYear().toString();

    const getTwoDigit = (e) => {
      return e.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false
      })
    }

    const Da = getTwoDigit(argDate.getDate());
    const Mo = getTwoDigit((argDate.getMonth() + 1));
    const yr = year[2] + year[3];
    const Hr = getTwoDigit(argDate.getHours() == 0 ? 12 : (argDate.getHours() > 12 ? argDate.getHours() - 12 : argDate.getHours()))
    const Mi = getTwoDigit(argDate.getMinutes());
    const AM_PM = argDate.getHours() >= 12 ? 'PM' : 'AM'

    // console.log(argDate, argDate.getHours() == 0 ? 12 : (argDate.getHours() > 12 ? argDate.getHours() - 12 : argDate.getHours()))
    let formatedDate = `${Hr}:${Mi} ${AM_PM}`//${Da}/${Mo}/${yr}
    // console.log(formatedDate, 'ajdhdhdhdhdh')
    return formatedDate //new Date(e).toUTCString()
  }

  useEffect(() => {
    // console.log(props.summaryData, 'props.summaryData')
    // let tile = props?.selectedTitle?.dbKey ? props?.selectedTitle?.dbKey : "totalTracked"
    // console.log(props?.selectedTitle, 'props?.selectedTitle?.dbKey')
    // console.log(tile, 'tile')
    setlastUpdated(Date.now())
  }, [props.summaryData])

  const [deviceStatusColorMapper] = useState({
    "In Service": "#7A7A7A",
    "At Risk": "#FF2E00",
    "To Be Found": "#FF2E00",
    "Being Found": "#007CB0",
    "Found": "#00B400",
    "Cannot Find": "#FF2E00",
    "Decommissioned": "#7A7A7A"
  })

  const INSERVICE = 0, TO_BE_FOUND = 1, BEING_FOUND = 2, FOUND = 3, NOT_FOUND = 4, DECOMMISSIONED = 9999, AT_RISK = 5;
  const [compareDataSet] = useState([INSERVICE, AT_RISK, TO_BE_FOUND, BEING_FOUND, FOUND, NOT_FOUND])

  const [accessoryStateColorMap] = useState({
    0: "#1D1E23",
    1: "#00864F",
    2: "#D70015"

  })


  let updatedDeviceCount = 0;
  // useEffect(() => {
  //   // console.log("DevicesListDashboard--->", props);
  //   getData(pageSize, location);
  // }, [sitevalue, location?.state?.deviceSearchObject?.filter, props?.selectedTitle]);

  useEffect(() => {
    if (dbSeacrh[0] == '' && dbSeacrh[1] == '') {
      getData(pageSize);
      // enabling sorting features (if sort and filter feature is enabled)
      if(sortAndFilterFlag) setDisableSorting(false);
    }
    else{
      // disabling sorting features
      setDisableSorting(true);
      // clearing filters
      setUpdateSelectedFilter({});
    }
  }, [dbSeacrh])


  const changeDataBeforeGivingToList = (devices) => {
    if (!devices || devices.length == 0) return
    // console.log("changeDataBeforeGivingToList--->", devices);
    const dl = devices;
    for (let i = 0; i < dl.length; i++) {
      if (dl[i]?.deviceState != null || dl[i]?.deviceState !== undefined) {
        const statusNumber = dl[i]?.deviceState;
        dl[i]["deviceStateName"] = deviceStateList[statusNumber];
      }
    }

    let newStructure = [];
    dl.map((val) => {
      let data = val;
      data["checkedInAt"] = data["checkedInAt"] ? getTimeAgo(data.checkedInAt) : null;
      // data['reportedAt'] = data['reportedAt'] ? new Date(data.reportedAt).toUTCString() : null;
      data["isCharging"] = data["isCharging"] ? "Charging" : "Not charging";
      // data["reportedAt"] = new Date(data.reportedAt).toUTCString();
      if (data["connectionState"] === 1) {
        data["connectionState"] = "Connected";
      } else if (data["connectionState"] === 2) {
        data["connectionState"] = "Not Connected";
      } else if (data["connectionState"] === 0) {
        data["connectionState"] = "Never Connected";
      }
      newStructure.push(data);
    });

    return newStructure;
  };

  //This code is not needed, since its usage is already commented below
  // const setTotalCountToState = async () => {
  //   let totalCount = (
  //     await firestore
  //       .collection("tenants")
  //       .doc(companyID)
  //       .collection("Devices")
  //       .get()
  //   ).docs.map((doc) => doc.data()).length;
  // };

  const getDefaultFireStoreQueryForDevice = () => firestore.collection("tenants").doc(companyID).collection("Devices");

  async function getData(currentPageSize, location) {
    unselectAll()
    let devices = [];
    setData([])
    setItemCount(0);
    props.getDeviceCount(0);
    // console.log(currentPageSize, 'currentPageSize')
    setsearchFromDb(false)
    // console.log(currentPageSize, 'a1')
    let itemsPerPage = currentPageSize; /* Should be fetched dynamically from UI */
    // if (pageSize == 100) {
    //   setPageSize(10);
    //   itemsPerPage = 10
    // }
    // console.log(currentPageSize, itemsPerPage, 'a2', state)

    setHidePagination(false);

    // if tile value is not selected then fetching data in normal procedure
    if (state === undefined) {
      // console.log('cammmeeedd', sitevalue)
      // // console.log('hiisiaisias',JSON.parse(sessionStorage.getItem('summaryCountData')))
      // setTotalCountToState();
      let dataCountToSet = 0

      console.log(dataCount,'mdv dataCount in getData')
      if (dataCount === null || undefined) {
        setItemCount(0); props.getDeviceCount(0); return;
      }
      else {
        let data = dataCount?.filter((x) => x.dbKey == (props?.selectedTitle?.dbKey ? props?.selectedTitle?.dbKey : 'totalTracked'))
        console.log(data,'data in getData')
        if (!data || data.length === 0) {
          console.log(data,'mdv If !data fn. will return')
          setItemCount(0);
          props.getDeviceCount(0);
          return;
        }
        dataCountToSet = data[0]?.sumCount;
        console.log('mdv dataCountToSet in getData before IF', dataCountToSet)
        if (!dataCountToSet && dataCountToSet != 0) { setItemCount(0); props.getDeviceCount(0); return };
        console.log('mdv dataCountToSet in getData after IF', dataCountToSet)
        setIsLoading(true);
        var query = getDefaultFireStoreQueryForDevice();

        // handle site 
        if (sitevalue === "Unassigned Devices") {
          query = query.where("siteName", "==", "");
        } else if (
          sitevalue !== "Unassigned Devices" &&
          sitevalue !== "All Devices"
        ) {
          query = query.where("siteName", "==", sitevalue.toUpperCase());
        }

        // apply filter
        if(appliedFilterCount > 0){
          query = getFilteredQuery(query);
        }



        let searchString = dbSeacrh[0].toUpperCase()
        let opt = dbSeacrh[1]
        if (searchString && opt) {
          dataCountToSet = 'check'
          itemsPerPage = 100
          // console.log('cameq')
          setsearchFromDb(true)
          query = query.orderBy(deviseTableMap[opt] ? deviseTableMap[opt] : opt).orderBy('reportedAt', 'desc').orderBy(firebaseObj.firestore.FieldPath.documentId(), "desc")
            .startAt(searchString).endAt(searchString + "\uf8ff")
        } else {
          //handling sorting....
          query = getSortingQuery(query);
        }



        setTempState({ selectedFilterKey: "totalTracked", itemsPerPage: pageSize, _key: "", _value: "", lowBatteryArr: [] });

        // fetched device data
        devices = (await query.limit(itemsPerPage).get()).docs.map((doc) => {
          let device = doc.data();
          device.id = doc.id;
          return device;
        }
        );
        console.log(dataCountToSet,'mdv dataCountToSet')
        console.log(devices, 'mdv devices')
        {devices.map(name => ( 
          name.id = name.modelNumber + "_" + name.serialNumber
        ))} 
        setItemCount(dataCountToSet == 'check' ? devices.length : dataCountToSet);
        props.getDeviceCount(dataCountToSet == 'check' ? devices.length : dataCountToSet);
        let originalArrayData = devices;
        
        setOriginalData(originalArrayData)
        setData(changeDataBeforeGivingToList(devices));

        if (devices.length > 0) {
          setEnableModDelete(true);
        } else {
          setEnableModDelete(false);
        }
      }


    } else {
      //tile value selected
      setIsLoading(true);
      await genericGetData(state, itemsPerPage, companyID);
      setIsLoading(false);
    }
    setIsLoading(false);
    setCurrentPage(0);
  }

  const getKeyAndValueFromConfigFile = (state, selectedFilterKey) => {
    let filterConfigObject = summaryConfig[0].mobile.filter;
    let _key, _value;
    const lowBatteryArr = [];

    if (selectedFilterKey === "totalTracked") {
      _key = "";
      _value = "";
    } else if (selectedFilterKey === "lowBattery") {
      Object.keys(filterConfigObject[selectedFilterKey]).forEach((key) => {
        lowBatteryArr.push({
          _key: key,
          _value: filterConfigObject[selectedFilterKey][key],
        });
      });
    } else {
      Object.keys(filterConfigObject[selectedFilterKey]).forEach((key) => {
        _key = key;
        _value = filterConfigObject[selectedFilterKey][key];
      });
    }

    return { _key, _value, lowBatteryArr };
  };

  const checkForDirection = (query, direction) => {
    try {
      if (direction != null && direction?.direction === "next") {
        query.orderBy('reportedAt', 'desc').startAfter(direction?.doc);
      } else if (direction != null && direction?.direction === "prev") {
        query.orderBy('reportedAt', 'desc').endBefore(direction?.doc);
      } else {
        query.orderBy('reportedAt', 'desc')
      }
      return query;
    } catch (error) {
      // console.log('Catch Issue---> ', error)
    }
  }

  //['neverConnected','lowBattery','checkedOut','isCharging','notCharging','notConnected']
  const getDevicesNew = async (sitevalue, key, value, lowBatteryArr, selectedFilterKey, itemsPerPage, direction) => {
    console.log('getDevicesNew',sitevalue, key, value, lowBatteryArr, selectedFilterKey, itemsPerPage, direction)
    setData([])
    setItemCount(0)
    props.getDeviceCount(0);
    try {
      let devices = [];
      let query = getDefaultFireStoreQueryForDevice()//.orderBy('reportedAt', 'desc');
      let searchString = dbSeacrh[0].toUpperCase()
      let opt = dbSeacrh[1]

      // handling site from dropdown
      if (sitevalue != null) {
        query = query.where("siteName", "==", sitevalue.toUpperCase())
      }

      // apply filter
      if(appliedFilterCount > 0){
        query = getFilteredQuery(query);
      }

      let page = pageSize;

      // handling when total tile is selected
      if (key === "" && value === "" && selectedFilterKey === "totalTracked") {
        if (!dataCount) { setItemCount(0); props.getDeviceCount(0); return }

        let data = dataCount?.filter((x) => x.dbKey == (props?.selectedTitle?.dbKey ? props?.selectedTitle?.dbKey : 'totalTracked'))
        if (!data || data.length === 0) { setItemCount(0); props.getDeviceCount(0); return }
        let dataCountToSet = data[0]?.sumCount;
        if (!dataCountToSet && dataCountToSet != 0) { setItemCount(0); props.getDeviceCount(0); return };

        // handling search 
        if (searchString && opt) {

          setsearchFromDb(true)
          dataCountToSet = 'check'
          page = 100
          
          query = query.orderBy(deviseTableMap[opt] ? deviseTableMap[opt] : opt).orderBy('reportedAt', 'desc').orderBy(firebaseObj.firestore.FieldPath.documentId(), "desc")
               .startAt(searchString).endAt(searchString + "\uf8ff")

        } else {
          //handling sorting....
          query = getSortingQuery(query);
        }

        // fetched the data
        devices = (await query.limit(page).get()).docs.map((doc) => {
          let device = doc.data();
          device.id = doc.id;
          return device;
        });

        {devices.map(name => ( 
          name.id = name.modelNumber + "_" + name.serialNumber
        ))} 
        setItemCount(dataCountToSet == 'check' ? devices.length : dataCountToSet);
        props.getDeviceCount(dataCountToSet == 'check' ? devices.length : dataCountToSet);
        return devices;
      }

      // handle when other tiles except lowBattery and total are selected
      if (selectedFilterKey !== "lowBattery" && selectedFilterKey !== "totalTracked") {
        query = query.where(key, "==", value);
      }

      // handle when low battery is selected
      if (selectedFilterKey === "lowBattery") {
        lowBatteryArr.forEach((items) => {
          query = query.where(items._key, "==", items._value);
        });
      }

      if (['neverConnected', 'lowBattery', 'checkedOut', 'isCharging', 'notCharging', 'notConnected'].includes(selectedFilterKey)) {
        query = query.where('deviceState', 'in', compareDataSet)
      }


      if (!dataCount) { setItemCount(0); props.getDeviceCount(0); return }
      let data = dataCount?.filter((x) => x.dbKey == (props?.selectedTitle?.dbKey ? props?.selectedTitle?.dbKey : 'totalTracked'))
      if (!data || data.length === 0) { setItemCount(0); props.getDeviceCount(0); return }

      let dataCountToSet = data[0]?.sumCount;

      if (!dataCountToSet && dataCountToSet != 0) { setItemCount(0); props.getDeviceCount(0); return };

      // handling the search
      if (searchString && opt) {
        dataCountToSet = 'check';
        setsearchFromDb(true)
        page = 100
        query = query.orderBy(deviseTableMap[opt] ? deviseTableMap[opt] : opt).orderBy('reportedAt', 'desc').orderBy(firebaseObj.firestore.FieldPath.documentId(), 'desc')
          .startAt(searchString).endAt(searchString + "\uf8ff")
      } else {
        //handling sorting....
        query = getSortingQuery(query);
      }


      // fetching data from db
      devices = (await query.limit(page).get()).docs.map((doc) => {
        let device = doc.data();
        device.id = doc.id;
        return device;
      });
      {devices.map(name => ( 
        name.id = name.modelNumber + "_" + name.serialNumber
      ))} 
      setItemCount(dataCountToSet == 'check' ? devices.length : dataCountToSet);
      props.getDeviceCount(dataCountToSet == 'check' ? devices.length : dataCountToSet);
      return devices;
    } catch (e) {
      console.log(e,'Catch error in getDevicesNew')
    }
  }

  async function genericGetData(state, itemsPerPage, companyID) {
    console.log(state, itemsPerPage, companyID,'mdv genericGetData')
    const selectedFilterKey = state?.deviceSearchObject?.filter;

    const { _key, _value, lowBatteryArr } = getKeyAndValueFromConfigFile(
      state,
      selectedFilterKey
    );

    //new  conditions !!!
    setTempState({ selectedFilterKey, itemsPerPage, _key, _value, lowBatteryArr });
    return await fetchingDevices(selectedFilterKey, itemsPerPage, _key, _value, lowBatteryArr, null);
  }

  const fetchingDevices = async (selectedFilterKey, itemsPerPage, _key, _value, lowBatteryArr, direction) => {
    setsearchFromDb(false)
    let totalDevices = [];
    if (sitevalue === "All Devices" || sitevalue === "Unassigned Devices") {
      let site = sitevalue === "Unassigned Devices" ? '' : null
      if (selectedFilterKey === "totalTracked") {
        totalDevices = await getDevicesNew(site, "", "", [], selectedFilterKey, itemsPerPage, direction)
      } else if (selectedFilterKey === "lowBattery") {
        totalDevices = await getDevicesNew(site, "", "", lowBatteryArr, selectedFilterKey, itemsPerPage, direction)
      } else {
        totalDevices = await getDevicesNew(site, _key, _value, [], selectedFilterKey, itemsPerPage, direction)
      }

    } else { // other site values
      if (selectedFilterKey === "totalTracked") {
        totalDevices = await getDevicesNew(sitevalue, "", "", [], selectedFilterKey, itemsPerPage, direction)
      } else if (selectedFilterKey === "lowBattery") {
        totalDevices = await getDevicesNew(sitevalue, "", "", lowBatteryArr, selectedFilterKey, itemsPerPage, direction)
      } else {
        totalDevices = await getDevicesNew(sitevalue, _key, _value, [], selectedFilterKey, itemsPerPage, direction)
      }
    }
    let originalArrayData = totalDevices
    setOriginalData(originalArrayData);
    setData(changeDataBeforeGivingToList(totalDevices));
    if(totalDevices) {
      if (totalDevices.length > 0) {
        setEnableModDelete(true);
      } else {
        setEnableModDelete(false);
      }
    }
    
  }

  async function next() {
    unselectAll()
    if (searchFromDb) {
      setCurrentPage(currentPage + 1);
      return
    }
    try {
      setIsLoading(true);
      let startDoc = sortingData.length? originalData[originalData.length - 1][sortingData[0]] : originalData[originalData.length - 1].reportedAt;
      let startDocID = originalData[originalData.length - 1].id;
      const { selectedFilterKey, itemsPerPage, _key, _value, lowBatteryArr } = tempState;
      let devices = [];
      let query = firestore.collection("tenants").doc(companyID).collection("Devices");

      // handled site
      if (sitevalue != 'All Devices' && sitevalue != 'Unassigned Devices') {
        query = query.where("siteName", "==", sitevalue.toUpperCase())
      } else if (sitevalue == 'Unassigned Devices') {
        query = query.where("siteName", "==", '')
      }

      // apply filter
      if(appliedFilterCount > 0){
        query = getFilteredQuery(query);
      }

      let searchString = dbSeacrh[0]
      let opt = dbSeacrh[1]
      if (_key === "" && _value === "" && selectedFilterKey === "totalTracked") {

        if (searchString && opt) {
          query = query.orderBy(deviseTableMap[opt] ? deviseTableMap[opt] : opt).orderBy('reportedAt', 'desc').orderBy(firebaseObj.firestore.FieldPath.documentId(), 'desc')
            .startAt(searchString).endAt(searchString + "\uf8ff")
        } else {
          //handling sorting....
          query = getSortingQuery(query);
        }
        devices = (await query.startAfter(startDoc, startDocID).limit(pageSize).get()).docs.map((doc) => {
          let device = doc.data();
          device.id = doc.id;
          return device;
        });
        {devices.map(name => ( 
          name.id = name.modelNumber + "_" + name.serialNumber
        ))} 
        let originalArrayData = devices
        setOriginalData(originalArrayData);
        setData(changeDataBeforeGivingToList(devices));
        setIsLoading(false);
        setCurrentPage(currentPage + 1);
        return;
      }
      if (selectedFilterKey !== "lowBattery" && selectedFilterKey !== "totalTracked") {
        query = query.where(_key, "==", _value);
      }
      if (selectedFilterKey === "lowBattery") {
        lowBatteryArr.forEach((items) => {
          query = query.where(items._key, "==", items._value);
        });
      }

      if (['neverConnected', 'lowBattery', 'checkedOut', 'isCharging', 'notCharging', 'notConnected'].includes(selectedFilterKey)) {
        query = query.where('deviceState', 'in', compareDataSet)
      }

      if (searchString && opt) {
        query = query.orderBy(deviseTableMap[opt] ? deviseTableMap[opt] : opt).orderBy('reportedAt', 'desc').orderBy(firebaseObj.firestore.FieldPath.documentId(), 'desc')
          .startAt(searchString).endAt(searchString + "\uf8ff")
      } else {
        //handling sorting....
        query = getSortingQuery(query);
      }
      devices = (await query.startAfter(startDoc, startDocID).limit(pageSize).get()).docs.map((doc) => {
        let device = doc.data();
        device.id = doc.id;
        return device;
      });
      {devices.map(name => ( 
        name.id = name.modelNumber + "_" + name.serialNumber
      ))} 
      let originalArrayData = devices
      setOriginalData(originalArrayData);
      setData(changeDataBeforeGivingToList(devices));
      setIsLoading(false);
      setCurrentPage(currentPage + 1);
    } catch (error) {
      setIsLoading(false);
      // console.log(error)
    }

  }

  async function prev() {
    console.log('prev')
    console.log(searchFromDb,'mdv prev searchFromDb')
    console.log(currentPage,'mdv prev currentPage')
    unselectAll()
    if (searchFromDb) {
      setCurrentPage(currentPage - 1);
      return
    }
    try {
      setIsLoading(true);
      let startDoc = sortingData.length? originalData[0][sortingData[0]] : originalData[0].reportedAt;
      let startDocID = originalData[0].id;
      const { selectedFilterKey, itemsPerPage, _key, _value, lowBatteryArr } = tempState;
      let devices = [];
      let query = firestore.collection("tenants").doc(companyID).collection("Devices")

      if (sitevalue != 'All Devices' && sitevalue != 'Unassigned Devices') {
        query = query.where("siteName", "==", sitevalue.toUpperCase())
      } else if (sitevalue == 'Unassigned Devices') {
        query = query.where("siteName", "==", '')
      }

      // apply filter
      if(appliedFilterCount > 0){
        query = getFilteredQuery(query);
      }

      let searchString = dbSeacrh[0]
      let opt = dbSeacrh[1]
      if (_key === "" && _value === "" && selectedFilterKey === "totalTracked") {
        //handling sorting....
        query = getSortingQuery(query);

        devices = (await query.endBefore(startDoc, startDocID).limitToLast(pageSize).get()).docs.map((doc) => {
          let device = doc.data();
          device.id = doc.id;
          return device;
        });
        let originalArrayData = devices
        setOriginalData(originalArrayData);
        setData(changeDataBeforeGivingToList(devices));
        if (devices.length > 0) {
          setEnableModDelete(true);
        } else {
          setEnableModDelete(false);
        }
        setIsLoading(false);
        setCurrentPage(currentPage - 1);
        return;
      }
      if (selectedFilterKey !== "lowBattery" && selectedFilterKey !== "totalTracked") {
        query = query.where(_key, "==", _value);
      }
      if (selectedFilterKey === "lowBattery") {
        lowBatteryArr.forEach((items) => {
          query = query.where(items._key, "==", items._value);
        });
      }
      if (['neverConnected', 'lowBattery', 'checkedOut', 'isCharging', 'notCharging', 'notConnected'].includes(selectedFilterKey)) {
        query = query.where('deviceState', 'in', compareDataSet)
      }

      //handling sorting....
      query = getSortingQuery(query);

      devices = (await query.endBefore(startDoc, startDocID).limitToLast(pageSize).get()).docs.map((doc) => {
        let device = doc.data();
        device.id = doc.id;
        return device;
      });
      {devices.map(name => ( 
        name.id = name.modelNumber + "_" + name.serialNumber
      ))} 
      console.log(devices,'mdv prev devices')
      let originalArrayData = devices
      setOriginalData(originalArrayData);
      setData(changeDataBeforeGivingToList(devices));
      console.log(changeDataBeforeGivingToList(devices),'mdv prev changeDataBeforeGivingToList(devices)')
      setIsLoading(false);
      setCurrentPage(currentPage - 1);
    } catch (error) {
      setIsLoading(false);
      console.log(error,'prev Catch error in pagination')
    }

  }

  async function searchValueFromDB(value, opt) {
    // setHidePagination(true);
    unselectAll()
    setsearchFromDb(true)
    try {
      setdbSeacrh([value.toUpperCase(), opt])
      props.devSearchField(value,opt);
      setIsLoading(true);
      // let startDoc = originalData[originalData.length - 1].reportedAt;

      const { selectedFilterKey, itemsPerPage, _key, _value, lowBatteryArr } = tempState;
      let devices = [];
      // itemsPerPage 
      let query = firestore.collection("tenants").doc(companyID).collection("Devices");

      // site handled
      if (sitevalue != 'All Devices' && sitevalue != 'Unassigned Devices') {
        query = query.where("siteName", "==", sitevalue.toUpperCase())
      } else if (sitevalue == 'Unassigned Devices') {
        query = query.where("siteName", "==", '')
      }

      // apply filter
      if(appliedFilterCount > 0){
        query = getFilteredQuery(query);
      }

      let searchString = value.toUpperCase()


      // if total tile is selected
      if (_key === "" && _value === "" && selectedFilterKey === "totalTracked") {

        // search process is handled
        if (searchString && opt) {
          
          query = query.orderBy(opt).orderBy('reportedAt', 'desc').orderBy(firebaseObj.firestore.FieldPath.documentId(), "desc")
            .startAt(searchString).endAt(searchString + "\uf8ff")

        } else {
          //handling sorting....
          query = getSortingQuery(query);
        }
        // let a = await query.get().then((snapshot) => snapshot.size)

        // device fetched
        devices = (await query.limit(100).get()).docs.map((doc) => {
          let device = doc.data();
          device.id = doc.id;
          return device;
        });
        {devices.map(name => ( 
          name.id = name.modelNumber + "_" + name.serialNumber
        ))} 
        setItemCount(devices.length);
        props.getDeviceCount(devices.length);

        let originalArrayData = devices
        setOriginalData(originalArrayData);
        setData(changeDataBeforeGivingToList(devices));
        setIsLoading(false);
        setCurrentPage(0);
        // setPageSize(100)
        return;
      }

      if (selectedFilterKey !== "lowBattery" && selectedFilterKey !== "totalTracked") {
        query = query.where(_key, "==", _value);
      }

      if (selectedFilterKey === "lowBattery") {
        lowBatteryArr.forEach((items) => {
          query = query.where(items._key, "==", items._value);
        });
      }
      if (['neverConnected', 'lowBattery', 'checkedOut', 'isCharging', 'notCharging', 'notConnected'].includes(selectedFilterKey)) {
        query = query.where('deviceState', 'in', compareDataSet)
      }

      if (searchString && opt) {
          query = query.orderBy(opt).orderBy('reportedAt', 'desc').orderBy(firebaseObj.firestore.FieldPath.documentId(), "desc")
          .startAt(searchString).endAt(searchString + "\uf8ff")

      } else {
        //handling sorting....
        query = getSortingQuery(query);
      }
      // let a = await query.get().then((snapshot) => snapshot.size)
      // // console.log(a, 'asasas')

      devices = (await query.limit(100).get()).docs.map((doc) => {
        let device = doc.data();
        device.id = doc.id;
        return device;
      });
      {devices.map(name => ( 
        name.id = name.modelNumber + "_" + name.serialNumber
      ))} 
      setItemCount(devices.length);
      props.getDeviceCount(devices.length);
      
      let originalArrayData = devices
      setOriginalData(originalArrayData);
      setData(changeDataBeforeGivingToList(devices));
      if (devices.length > 0) {
        setEnableModDelete(true);
      } else {
        setEnableModDelete(false);
      }
      setIsLoading(false);
      setCurrentPage(0);
      // setPageSize(100)
    } catch (error) {
      setIsLoading(false);
      // console.log(error, 'sdfsdfxfgdf')
    }

  }

  function onClickTableRow(event, rowData) {
    unselectAll()
    history.push({
      pathname: "/dashboard/devicedetail",
      state: { tableData: rowData },
    });
  }

  const getAddedNote = (value) => {
    let toUpdateData = selectedData;
    for (let index = 0; index < toUpdateData.length; index++) {
      const element = toUpdateData[index];
      let docId = `${element.modelNumber}_${element.serialNumber}`;
      const dataTosendToDB = { note: value };
      addData(dataTosendToDB, docId);
    }
  };

  async function addData(dataTodb, docId) {
    let companyID = context.currentUser.claims.companyID;
    setIsLoading(true);
    await firestore
      .collection("tenants")
      .doc(companyID)
      .collection("Devices")
      .doc(docId)
      .update({ ...dataTodb });
    setIsLoading(false);
    if (dataTodb.note) {
      serverResponse.current = { status: 'Success', msg: 'Note Updated' }
      setSnackbarOpen(true);
    }

    getData(pageSize, location);
  }

  async function addMonitor(docTodb, dataTodb, docId) {
    let companyID = context.currentUser.claims.companyID;
    setIsLoading(true);
    await firestore
      .collection("tenants")
      .doc(companyID)
      .collection("Devices")
      .doc(docId)
      .collection("Monitor")
      .doc(docTodb)
      .set({ ...dataTodb }, { merge: true });

    setIsLoading(false);
    getData(pageSize, location);
  }

  async function sendDataToFire(finalData, docId, completed) {
    setIsLoading(true);
    let response = await firebaseUtil.recomDecom(finalData, t);
    if (!response.status) {
      serverResponse.current = {
        status: false,
        msg: "Error Occured"
      }
      if(response.msg == DEVICELIST_CONSTANT.licenseNotAvailable){
        serverResponse.current.msg = t('messages.error.err54');
      }
      setSnackbarOpen(true);
      setIsLoading(false);
      return
    }
    serverResponse.current = {
      status: true,
      msg: response.msg
    };
    setSnackbarOpen(true);
    setIsLoading(false);
    if (completed) {
      addUserModalRef.current.toggleDialog();
    }

  }

  function onActionValueChange(value) {

    if (value.action == 'e' || value.action == 'd') {
      PerformEditAction(value);
      return
    }

    try {
      let actionValue = value.label
      if (selectedData.length > 0) {
        updatedDeviceCount = 0;
        if (actionValue === "Add Notes") {
          addUserModalRef.current.toggleDialog();
        } else if (
          actionValue === "Mark Device for finding" ||
          actionValue === "Mark device as InService" 
        ) {
          if (selectedData.length === 1) {
            if (selectedData[0].deviceState === 0 && actionValue === "Mark device as InService") {
              setIsLoading(false);
              serverResponse.current = {
                status: false,
                msg: t('messages.error.err53')
              };
              setSnackbarOpen(true);
              return;
            }
            if (selectedData[0].deviceState === 1 && actionValue === "Mark Device for finding") {
              setIsLoading(false);
              serverResponse.current = {
                status: false,
                msg: t('messages.error.err53')
              };
              setSnackbarOpen(true);
              return;
            }
          }


          if (actionValue == 'Mark device as InService') {
            let inServicesData = selectedData.filter((x) => x.deviceState == 0)
            if (inServicesData && inServicesData.length == selectedData.length) {
              setIsLoading(false);
              serverResponse.current = {
                status: false,
                msg: t('messages.error.err53')
              };
              setSnackbarOpen(true);
              return;
            }
          } else if (actionValue == 'Mark Device for finding') {
            let findingData = selectedData.filter((x) => x.deviceState == 1)
            if (findingData && findingData.length == selectedData.length) {
              setIsLoading(false);
              serverResponse.current = {
                status: false,
                msg: t('messages.error.err53')
              };
              setSnackbarOpen(true);
              return;
            }
          }


          const alteredSelectedData = selectedData.map((item) => {
            if (
              actionsToCode[actionValue] != null ||
              actionsToCode[actionValue] !== undefined
            ) {
              if (
                actionsToCode[actionValue][item["deviceState"].toString()] !=
                null ||
                actionsToCode[actionValue][item["deviceState"].toString()] !==
                undefined
              ) {
                // v  dl[i]["deviceStateName"] = deviceStateList[statusNumber];
                updatedDeviceCount++;
                return {
                  ...item,
                  deviceState:
                    actionsToCode[actionValue][item["deviceState"].toString()],
                  deviceStateName:
                    deviceStateList[
                    actionsToCode[actionValue][item["deviceState"].toString()]
                    ],
                };
              }
              return item;
            } else {
              return item;
            }
          });
          alteredSelectedData.forEach((item) => {
            let dataToSendToDb = {
              deviceState: item["deviceState"],
              deviceStateUpdatedBy: 0
            };

            if(actionValue == 'Mark Device for finding') {
              dataToSendToDb = {
                ...dataToSendToDb,
                tobeFoundTimestamp:Date.now(),
                deviceStateUpdateAutomationSource:""
              }
            }
            addMonitor(
              "DeviceState",
              dataToSendToDb,
              `${item.modelNumber}_${item.serialNumber}`
            );
            addData(
              dataToSendToDb,
              `${item.modelNumber}_${item.serialNumber}`
            );
            return;
          });
          serverResponse.current = {
            status: "Success",
            msg: `${updatedDeviceCount} ${t('devicesUpdated')}`,
          };
          setSnackbarOpen(true);
        } else if (actionValue === "Refresh Current Device's Location") {
          let findingData = selectedData.filter((x) => x.connectionState != "Connected");
          if (findingData && findingData.length == selectedData.length) {
            setIsLoading(false);
            serverResponse.current = {
              status: false,
              msg: t('messages.error.err53')
            };
            setSnackbarOpen(true);
            return;
          } else {
            selectedData.forEach((item) => {
              if(item.connectionState == "Connected"){
                updatedDeviceCount++;              
                addMonitor(
                  "DeviceGPSState",
                  { gpsState: Date.now() },
                  `${item.modelNumber}_${item.serialNumber}`
                );
  
              }
          });
          if (updatedDeviceCount > 0) {
            serverResponse.current = {
              status: "Success",
              msg: `Request sent to ${updatedDeviceCount} devices`,
            };
            setSnackbarOpen(true);
            return;
          } else {
            serverResponse.current = {
              status: false,
              msg: t('messages.error.err53')
            };
            setSnackbarOpen(true);
            return;
          }
          }
        } else if (actionValue === "Play Sound") {
          let findingData = selectedData.filter((x) => x.connectionState != "Connected")
          if (findingData && findingData.length == selectedData.length) {
            setIsLoading(false);
            serverResponse.current = {
              status: false,
              msg: t('messages.error.err53')
            };
            setSnackbarOpen(true);
            return;
          } else {
              selectedData.forEach((item) => {
                if(item.connectionState == "Connected"){                
                  updatedDeviceCount++;
                  addMonitor("BeepState", { chirpStatus: Date.now()}, `${item.modelNumber}_${item.serialNumber}`);
                }
            });
            if (updatedDeviceCount > 0) {
              serverResponse.current = {
                status: "Success",
                msg: `Request sent to ${updatedDeviceCount} devices`,
              };
              setSnackbarOpen(true);
              return;
            } else {
              serverResponse.current = {
                status: false,
                msg: t('messages.error.err53')
              };
              setSnackbarOpen(true);
              return;
            }
          }          
        } else if (actionValue === "Recommission Device") {

          let checkArrayHasDeCDevice = false;
          selectedData.forEach((item, indexIs) => {

            if (selectedData[indexIs].deviceState === 9999) {
              checkArrayHasDeCDevice = true;
              return;
            }
          })
          if (checkArrayHasDeCDevice) {
            selectedData.forEach((item, idx) => {

              if (
                actionsToCode[actionValue] != null ||
                actionsToCode[actionValue] !== undefined
              ) {
                if (
                  actionsToCode[actionValue][item["deviceState"].toString()] !=
                  null ||
                  actionsToCode[actionValue][item["deviceState"].toString()] !==
                  undefined
                ) {
                  // v  dl[i]["deviceStateName"] = deviceStateList[statusNumber];
                  updatedDeviceCount++;
                  let postData = {
                    udi: `${item.modelNumber}_${item.serialNumber}`,
                    action: 0,
                    tenantId: context.currentUser.claims.companyID,
                    isDeviceCheckedOut: item.checkOutState,
                  };
                  sendDataToFire(
                    postData,
                    `${item.modelNumber}_${item.serialNumber}`,
                    idx + 1 === selectedData.length
                  );
                  return;
                }
              }
            });

          } else {
            serverResponse.current = {
              status: false,
              msg: t('messages.error.err53')
            };
            setSnackbarOpen(true);
            return;
          }

        } else if (actionValue === "Decommission Device") {
          let checkArrayContainsOthers = false;
          selectedData.forEach((item, indexIs) => {
            if (selectedData[indexIs].deviceState !== 9999) {
              checkArrayContainsOthers = true;
              return;
            }
          })
          if (checkArrayContainsOthers) {

            selectedData.forEach((item, idx) => {
              if (
                actionsToCode[actionValue] != null ||
                actionsToCode[actionValue] !== undefined
              ) {
                if (
                  actionsToCode[actionValue][item["deviceState"].toString()] !=
                  null ||
                  actionsToCode[actionValue][item["deviceState"].toString()] !==
                  undefined
                ) {
                  // v  dl[i]["deviceStateName"] = deviceStateList[statusNumber];
                  updatedDeviceCount++;
                  let postData = {
                    udi: `${item.modelNumber}_${item.serialNumber}`,
                    action: 9999,
                    tenantId: context.currentUser.claims.companyID,
                    isDeviceCheckedOut: item.checkOutState,
                  };
                  sendDataToFire(
                    postData,
                    `${item.modelNumber}_${item.serialNumber}`,
                    idx + 1 === selectedData.length
                  );
                  return;
                }
              }
            });
            //addUserModalRef.current.toggleDialog();

          } else {
            serverResponse.current = {
              status: false,
              msg: t('messages.error.err53'),
            };
            setSnackbarOpen(true);
          }
        } else if (actionValue === "Cannot Find") {
          if (selectedData.length === 1) {
            // if it is already in inservice/cannot find/at risk/decom
            if ([0, 4, 5, 9999].indexOf(Number(selectedData[0].deviceState)) > -1) {
              setIsLoading(false);
              serverResponse.current = {
                status: false,
                msg: t('messages.error.err53')
              };
              setSnackbarOpen(true);
              return;
            }
          }

          let unMatchedDeviceCount = 0;

          const alteredSelectedData = selectedData.map((item) => {
            if (
              actionsToCode[actionValue] != null ||
              actionsToCode[actionValue] !== undefined
            ) {
              if (
                actionsToCode[actionValue][item["deviceState"].toString()] !=
                null ||
                actionsToCode[actionValue][item["deviceState"].toString()] !==
                undefined
              ) {
                updatedDeviceCount++;
                return {
                  ...item,
                  deviceState:
                    actionsToCode[actionValue][item["deviceState"].toString()],
                  deviceStateName:
                    deviceStateList[
                    actionsToCode[actionValue][item["deviceState"].toString()]
                    ],
                };
              }
              else{
                unMatchedDeviceCount++;
                return item;
              }
            } else {
              return item;
            }
          });
          console.log("cannot find: ", unMatchedDeviceCount);
          if(unMatchedDeviceCount > 0){
            let errMSG = `${unMatchedDeviceCount} devices are in inservice, cannot find or decommisioned state. Please unselect them`;
            if(showDLR) errMSG = `${unMatchedDeviceCount} devices are in inservice, atrisk, cannot find or decommisioned state. Please unselect them`;
            serverResponse.current = {
              status: false,
              msg: errMSG,
            };
            setSnackbarOpen(true);
            setTimeout(()=> refreshPageClicked(), 5000);
            return;
          }
          else{
            alteredSelectedData.forEach((item) => {
              const dataToSendToDb = {
                deviceState: item["deviceState"],
                deviceStateUpdatedBy: 0
              };
              addMonitor(
                "DeviceState",
                dataToSendToDb,
                `${item.modelNumber}_${item.serialNumber}`
              );
              addData(
                dataToSendToDb,
                `${item.modelNumber}_${item.serialNumber}`
              );
              return;
            });
            serverResponse.current = {
              status: "Success",
              msg: `${updatedDeviceCount} ${t('devicesUpdated')}`,
            };
            setSnackbarOpen(true);
            return;
          }
        }
      } else {
        serverResponse.current = {
          status: "Success",
          msg: "Please select one or more devices to perform the action",
        };
        setSnackbarOpen(true);
      }
    } catch (e) {
      serverResponse.current = {
        status: false,
        msg: t('messages.error.err53'),
      };
      setSnackbarOpen(true);
    }
  }

  function onChangeManageBtn(buttonValue, buttonName) {
    console.log(buttonValue, buttonName,'buttonValue, buttonName')
    if (buttonValue === 'MODIFY' || buttonValue === 'DELETE') {
      CsvCompModalRef.current.toggleDialog();
      //getInitialSitesData();

    }
    else {
      DevicesManageAMDModalRef.current.toggleDialog();
    }
    setManageBtnValue({ name: buttonName, value: buttonValue, page: 'DEVICES' })
  }

  function continueBtnClicked(value) {
    unselectAll()
    if (value.importMethod === "UPLOAD_CSV") {
      //getInitialSitesData();
      CsvCompModalRef.current.toggleDialog();

    }
    if (value.importMethod === "MANUAL") {
      if (value.type.toLowerCase() == t('csvModal.Add').toLowerCase()) {
        AddDevicesModalRef.current.toggleDialog();
      }
    }

  }

  const AddModiDeletePopUpTrigger = (e) => {
    if (e?.msg?.show) {
      serverResponse.current = {
        status: !e.msg.error,
        msg: e.msg.data,
      };
      setSnackbarOpen(true);
    }
    if (e?.close) {
      if (e?.from == 'add') { AddDevicesModalRef.current.toggleDialog(); }
      else if (e?.from == 'modify') { ModifyDevicesModalRef.current.toggleDialog(); }
    }
    if (e?.needToLoad) {
      getData(pageSize, location)
    }
  }

  const [modifyDevicesPopupData, setmodifyDevicesPopupData] = useState({})

  const PerformEditAction = (e) => {
    if (e.action == 'd') {
      let btnData = [
        { scope: 'delete', innerTxt: t('cancel'), proceed: false, class: '' },
        { scope: 'delete', innerTxt: t('confirm'), proceed: true, class: 'confirm' }
      ]
      setconfirmPopData({
        title: t('delete'),
        btnData: btnData,
        msg: `${t('deviceDetail.message')}`,
        topMsg: `${selectedData.length} ${t('deviceDetail.device')}${selectedData.length == 1 ? '' : 's'} ${t('deviceDetail.selected')}`,
        needcheck: selectAll,
        checktext: 'Want to delete all records?',
      })
      confirmationModalRef.current.toggleDialog();
    } else if (e.action == 'e') {
      ModifyDevicesModalRef.current.toggleDialog();
      let filterData = {
        site: null, title_key: null, title_value: null, title_lowBatteryArr: null, state: null, searchString: null, opt: null,
      }

      //site
      if (sitevalue != 'All Devices' &&
        sitevalue != 'Unassigned Devices') { filterData.site = sitevalue.toUpperCase() }
      else if (sitevalue == 'Unassigned Devices') { filterData.site = ''; }

      let state = props?.selectedTitle?.dbKey ? props?.selectedTitle?.dbKey : 'totalTracked'

      const { _key, _value, lowBatteryArr } = getKeyAndValueFromConfigFile('', state)

      filterData.title_key = _key;
      filterData.title_value = _value;
      filterData.title_lowBatteryArr = lowBatteryArr;
      filterData.state = state;
      filterData.searchString = dbSeacrh[0]
      filterData.opt = dbSeacrh[1]

      setmodifyDevicesPopupData({
        edit: e.key,
        needcheck: e.key == 'edit_site' ? selectAll : false,
        checktext: 'Want to update all records?',
        updateData: selectedData,
        filterData: filterData
      })
    }
  }

  const fromConfirmationPopup = (e) => {
    if (e.btnData.scope == 'delete') {
      if (e.btnData.proceed) {
        deleteDevices(e.checkAll)
      }
      confirmationModalRef.current.toggleDialog();
    }

  }


  const deleteAllDevices = async () => {
    try {
      setIsLoading(true)
      const getQuery = () => {

        let query = firestore.collection("tenants")
          .doc(companyID)
          .collection('Devices')

        //site
        if (sitevalue != 'All Devices' && sitevalue != 'Unassigned Devices') {
          query = query.where("siteName", "==", sitevalue.toUpperCase())
        } else if (sitevalue == 'Unassigned Devices') {
          query = query.where("siteName", "==", '')
        }

        let state = props?.selectedTitle?.dbKey ? props?.selectedTitle?.dbKey : 'totalTracked'

        const { _key, _value, lowBatteryArr } = getKeyAndValueFromConfigFile('', state)

        //state
        if (props?.selectedTitle &&
          props?.selectedTitle.dbKey != "totalTracked" &&
          props?.selectedTitle.dbKey != "lowBattery") {
          query = query.where(_key, "==", _value);
        }

        if (props?.selectedTitle?.dbKey === "lowBattery") {
          lowBatteryArr.forEach((items) => {
            query = query.where(items._key, "==", items._value);
          });
        }

        let searchString = dbSeacrh[0]
        let opt = dbSeacrh[1]

        if (searchString && opt) {
          query = query.orderBy(opt).orderBy('reportedAt', 'desc')
            .startAt(searchString).endAt(searchString + "\uf8ff")
        } else {
          query = query.orderBy('reportedAt', 'desc')
        }

        return query
      }

      const deleteQuery = async () => {

        let batch = firestore.batch();

        const snapshot = await getQuery()
          // .orderBy('reportedAt')
          .limit(490).get();
        const batchSize = snapshot.size;

        if (batchSize === 0) {
          setTimeout(() => {
            AddModiDeletePopUpTrigger({
              from: 'delete',
              msg: { show: true, error: false, data: t("Mo_Dash.placeholders.AllDevicesDeletedSuccessfully") },
              needToLoad: true
            })
          }, 1000);

          return
        } else {
          snapshot.docs.forEach((doc) => {
            batch.delete(doc.ref);
          });
          await batch.commit();
          deleteQuery()
        }
      }
      deleteQuery()

    } catch (e) {
      setTimeout(() => {
        AddModiDeletePopUpTrigger({
          from: 'delete',
          msg: { show: true, error: true, data: t("Mo_Dash.placeholders.DeletingDevices") },
          needToLoad: true
        })
      }, 1000);
    }

  }


  const deleteDevices = async (deleteAll) => {
    try {
      if (deleteAll) {
        deleteAllDevices()
        return
      }

      let batch = firestore.batch();
      setIsLoading(true);
      selectedData.forEach(element => {

        let docRef = firestore.collection("tenants")
          .doc(companyID)
          .collection('Devices')
          .doc(element.modelNumber + '_' + element.serialNumber);

        batch.delete(docRef)
      });

      await batch.commit();

      setTimeout(() => {
        let data = selectedData.length
        AddModiDeletePopUpTrigger({
          from: 'delete',
          msg: { show: true, error: false, data: t("Mo_Dash.placeholders.DevicesDeletedSuccessfully", { data }) },

          needToLoad: true
        })
      }, 1000);

    } catch (error) {

      setIsLoading(false);
      AddModiDeletePopUpTrigger({
        from: 'delete',
        msg: { show: true, error: true, data: t("Mo_Dash.placeholders.DeletingDevices") },
        needToLoad: false
      })
    }

  }

  const [selectAll, setselectAll] = useState(false)

  const onSelectAllChecked = () => {
    let rowData = []
    console.log(data);
    if (dbSeacrh[0] == '' && dbSeacrh[1] == '') {
      data.forEach(element => {
        let _data = { ...element, ...{ checked: !selectAll } }
        rowData.push(_data)
      });
    } else {
      for (let index = 0; index < pageSize; index++) {
        const element = data[(currentPage * pageSize) + index];
        if (element) {
          let _data = { ...element, ...{ checked: !selectAll } }
          rowData.push(_data)
        }
      }
    }
    let ddaa = []
    if (dbSeacrh[0] == '' && dbSeacrh[1] == '') {
      data.forEach(element => {
        let _data = { ...element, ...{ checked: !selectAll } }
        ddaa.push(_data)
      });
    } else {
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (element) {
          let _data
          if (index >= currentPage * pageSize && index <= (((currentPage + 1) * pageSize) - 1)) {
            _data = { ...element, ...{ checked: !selectAll } }
          } else { _data = element }
          ddaa.push(_data)
        }
      }
    }
    setSelectedData(selectAll ? [] : rowData)
    setselectAll(!selectAll)
    setData(ddaa)
    onRwoSelected(!_ds)
  }

  const unselectAll = () => {
    if (data && data.length != 0) {
      let _data = data
      _data.forEach(element => {
        element.checked = false
      });
      setSelectedData([])
      setselectAll(false)
      onRwoSelected(!_ds)
    }
  }

  function refreshPageClicked() {
    getData(pageSize);
    getTitleData()
    setlastUpdated(Date.now())
  }

  function onCancelHit() {
    allDevData = [];
  }


  var menus = [];

  if (!isManager) {
    //Add site is available only for ADMIN
    menus.push({ name: t('csvModal.Add'), value: 'ADD', active: false });
  }

  if (isManager) {
    //Manager can modify only if the option is turned ON in global config settings
    if (globalAppSettings?.userRoleSettings?.manager?.Devices && globalAppSettings?.userRoleSettings?.manager?.Devices[0] === 'update') {
      //For managers, Update name is allowed only when the userRoleSettings is Write
      menus.push({ name: t('csvModal.Modify'), value: 'MODIFY', active: !enableModDelete });
    }
  }
  else {
    //For admin role, modify is alwasy applicable 
    menus.push({ name: t('csvModal.Modify'), value: 'MODIFY', active: !enableModDelete });
  }



  if (!isManager) {
    //Delete site is available only for ADMIN
    menus.push({ name: t('csvModal.Delete'), value: 'DELETE', active: !enableModDelete });
  }

  function onCancelHit() {
    allDevData = [];
  }

  const openDialog= () =>{
    setColumnPreferenceOpen(true)
  }
  const closeDialog = ()=>{
    setColumnPreferenceOpen(false)
  }

  const handleSorting = async (orderBy, orderDirection) => {
    try{
      if(orderBy > -1){
        setSortingData([finalColumns[orderBy]?.field, orderDirection]);
      }
      else{
        setSortingData([])
      }
    }
    catch(err){
      console.log(err);
    }
    return;
  }

  const getTilesInfoFromFilter = filters => {
    for(let item in filters){
      if(filters[item].length > 0 && item != "siteName" && item != "modelNumber"){
        if(filters[item].length == 1){
          if(item == "deviceState"){
            if(filters[item][0] == INSERVICE){
              return "totalTracked"
            }
            else if(filters[item][0] == TO_BE_FOUND){
              return "toBeFound"
            }
            else if(filters[item][0] == BEING_FOUND){
              return "beingFound"
            }
            else if(filters[item][0] == FOUND){
              return "found"
            }
            else if(filters[item][0] == NOT_FOUND){
              return "notFound"
            }
            else if(filters[item][0] == DECOMMISSIONED){
              return "decommissioned"
            }
          }
          else if(item == "connectionState"){
            if(filters[item][0] == 0){
              return "neverConnected"
            }
            else if(filters[item][0] == 1){
              return "totalTracked"
            }
            else if(filters[item][0] == 2){
              return "notConnected"
            }
          }
          else if(item == "isCharging"){
            if(filters[item][0] == 0){
              return "notCharging"
            }
            else if(filters[item][0] == 1){
              return "isCharging"
            }
          }
          else if(item == "misc"){
            if(filters[item][0] == "checkOutState"){
              return "checkedOut"
            }
            else if(filters[item][0] == "lowBattery"){
              return "lowBattery"
            }
            else if(filters[item][0] == "isIdle"){
              return "idle"
            }
          }
          else{
            return "totalTracked"
          }
        }
        else{
          return "totalTracked"
        }
      }
    }
  }

  const applyFilter = (filters, isApplied) => {

    console.log("applyFilter called with ", filters, isApplied);

    let count = 0;

    for(let item in filters){
      if(filters[item] && filters[item].length > 0){
        count++;
      }
    }
    setAppliedFilterCount(count);
    setAppliedFilter(filters);
    setOpenFilterMenu(false);

    // clearing tiles selection
    if(isApplied){
      setdbSeacrh(['', ''])
      setSearchText("");
      props.devSearchField('','')

      let targetSite = { label: 'All Devices', value: 'All Devices' };
      if("siteName" in filters && filters.siteName.length == 1){
        targetSite = { label: filters.siteName[0], value: filters.siteName[0] };
      }

      props.onFilterChange({ target: targetSite }, 'SITES_FILTER');

      let summaryCountData = sessionStorage.getItem("summaryCountData");
      if(summaryCountData){
        let selectedTilesFromFilter = "totalTracked";
        if(count == 1){
          selectedTilesFromFilter = getTilesInfoFromFilter(filters);
        }
        else if(count == 2 && "siteName" in filters && filters.siteName.length > 0){
          selectedTilesFromFilter = getTilesInfoFromFilter(filters);
        }
        summaryCountData = JSON.parse(summaryCountData);
        const valueIs = summaryCountData.find((data)=> data.dbKey == selectedTilesFromFilter)
        if(valueIs){
          props.setTitle(valueIs)
          sessionStorage.setItem('selectedTile', JSON.stringify(valueIs))
          history.replace({
            pathname: location.pathname,
            state: {
              deviceSearchObject: valueIs,
              selectedSitevalue: "All Devices"
            }
          })
        }
      }
      setFilterAppliedStatus(1);
    }
  }

  const getFilteredQuery = query => {
    const tempFilters = {...appliedFilter}
    for(let item in tempFilters){
      if(tempFilters[item] && tempFilters[item].length > 0){
        let tempArr = [...tempFilters[item]];

        // handling isCharging
        if(item == "isCharging" && tempArr.length > 0){
          for(let i=0; i<tempArr.length; i++){
            tempArr[i] = tempArr[i] == 0 ? false : true;
          }
        }
        // handling Unassigned Devices site
        if(item == "siteName" && tempArr.length > 0){
          let foundAt = tempArr.indexOf("Unassigned Devices");
          if(foundAt > -1){
            tempArr[foundAt] = "";
          }
        }

        // handling miscellaneous
        if(item == "misc" && tempArr.length > 0){
          if(tempArr[0] == "checkOutState" || tempArr[0] == "isIdle"){
            query = query.where(tempArr[0], "==", true)
          }
          else if(tempArr[0] == "lowBattery"){
            query = query.where("isCharging", "==", false);
            query = query.where("lowBattery", "==", true);
          }
        }
        else{
          if(tempArr.length == 1){
            query = query.where(item, "==", tempArr[0])
          }
          else if(tempArr.length >= 1){
            
            let index = tempArr.indexOf("ALL");
            if(index > -1){
              tempArr.splice(index, 1);
            }
            query = query.where(item, "in", tempArr)
          }
        }
      }
    }
    return query;
  }

  const getSortingQuery = query => {
    console.log(disableSorting, sortingData);
    if(!disableSorting && sortingData.length){
      query = query.orderBy(sortingData[0], sortingData[1])
      query = query.orderBy(firebaseObj.firestore.FieldPath.documentId(), sortingData[1]);
      return query;
    }
    else{
      query = query.orderBy('reportedAt', 'desc');
      query = query.orderBy(firebaseObj.firestore.FieldPath.documentId(), "desc");
      return query;
    }
  }

  const fetchSiteList = async isAll => {
    try{
      let QUERY = firestore
                      .collection('tenants')
                      .doc(companyID)
                      .collection('SiteLocations')
                      .orderBy("siteName");

      let count = 0;

      if(!isAll){
        QUERY = QUERY.limit(FILTER_CONSTANT.INITIAL_OPTION_LOADED - 1);

        count = (await firestore
            .collection('tenants')
            .doc(companyID)
            .collection('SiteLocations').get()).size;

        count++;
      }

      let sites = (await QUERY.get()).docs.map((doc) => { 
        let data = doc.data();
        return {
          label: data.displaySiteName,
          value: data.siteName
        }
      });

      sites.unshift({
        label: "Unassigned Devices",
        value: "Unassigned Devices"
      })

      if(isAll)  count = sites.length;

      console.log({
          list: sites,
          count
      })

      return {
        list: sites,
        count
      }
    }
    catch(err){
      console.log(err);
      return {
          list: [],
          count: 0
      }
    }
  }

  const searchSite = async site => {
    try{
      if(site == "UNASSIGNED DEVICES"){
        return [
          {
            label: "Unassigned Devices",
            value: "Unassigned Devices"
          }
        ]
      }

      let sites = (await firestore
                    .collection('tenants')
                    .doc(companyID)
                    .collection('SiteLocations')
                    .orderBy("siteName")
                    .startAt(site).endAt(site + "\uf8ff")
                    .get()).docs.map((doc) => { 
                      let data = doc.data();
                      return {
                        label: data.displaySiteName,
                        value: data.siteName
                      }
                    });

      return sites;
    }
    catch(err){
      console.log(err);
      return []
    }
  }

  const fetchModelList = async isAll => {
    try{
      let QUERY = firestore.collection('tenants').doc(companyID).collection('DeviceModels')

      if(isManager && sitevalue){
        QUERY = QUERY.where("siteName", "array-contains", sitevalue)
      }

      QUERY = QUERY.orderBy("modelNumber");

      let count = 0;

      if(!isAll){
        QUERY = QUERY.limit(FILTER_CONSTANT.INITIAL_OPTION_LOADED);

        if(isManager && sitevalue){
          count = (await firestore.collection('tenants').doc(companyID).collection('DeviceModels').where("siteName", "array-contains", sitevalue).get()).size;
        }
        else{
          count = (await firestore.collection('tenants').doc(companyID).collection('DeviceModels').get()).size;
        }
      }

      let models = (await QUERY.get()).docs.map((doc) => { 
        let data = doc.data();
        return {
          label: data.displayModelNumber,
          value: data.modelNumber
        }
      });

      console.log(models);

      if(isAll)  count = models.length;

      return {
        list: models,
        count
      }
    }
    catch(err){
      console.log(err);
      return {
          list: [],
          count: 0
      }
    }
  }

  const searchModel = async model => {
    try{
      let QUERY = firestore.collection('tenants').doc(companyID).collection('DeviceModels')

      if(isManager && sitevalue){
        QUERY = QUERY.where("siteName", "array-contains", sitevalue)
      }

      QUERY = QUERY.orderBy("modelNumber").startAt(model).endAt(model + "\uf8ff")

      let models = (await QUERY.get()).docs.map((doc) => { 
                      let data = doc.data();
                      return {
                        label: data.displayModelNumber,
                        value: data.modelNumber
                      }
                    });

      return models;
    }
    catch(err){
      console.log(err);
      return [];
    }
  }

  const filterActions = {
    search: {
      siteName: searchSite,
      modelNumber: searchModel
    },
    fetchAll: {
      siteName: fetchSiteList,
      modelNumber: fetchModelList
    },
    fetchInitialData: {
      siteName: fetchSiteList,
      modelNumber: fetchModelList
    }
  }

  
  const colJson = {
    friendlyName: {
      sorting: false,
      title: "Device Name",
      field: "friendlyName",
      cellStyle: {
        minWidth: 150,
        maxWidth: 150,
      },
      render: rowData => {
        return (<span>
          {rowData?.friendlyName?.length > 10 ?
            <Tooltip title={rowData.friendlyName} arrow placement="bottom-start">
              <CuzCell>{rowData.friendlyName}</CuzCell>
            </Tooltip>
            :
            <CuzCell>{rowData.friendlyName}</CuzCell>
          }
        </span>
        )
      }
    },
    displaySerialNumber: {
      sorting: false,
      title: "Serial #",
      field: "displaySerialNumber",
      cellStyle: {
        minWidth: 200,
        maxWidth: 200,
      },
      render: rowData => {
        return (<span>
          {rowData?.serialNumber?.length > 15 ?
            <Tooltip title={rowData.serialNumber} arrow placement="bottom-start">
              <CuzCell>{rowData.serialNumber}</CuzCell>
            </Tooltip>
            :
            <CuzCell>{rowData.serialNumber}</CuzCell>
          }
        </span>
        )
      }
    },
    modelNumber:{
      sorting: false,
      title: "Device Model",
      field: "modelNumber",
      cellStyle: {
        minWidth: 150,
        maxWidth: 150,
      },
      render: rowData => {
        return (<span>
          {rowData?.modelNumber?.length > 10 ?
            <Tooltip title={rowData.modelNumber} arrow placement="bottom-start">
              <CuzCell>{rowData.modelNumber}</CuzCell>
            </Tooltip>
            :
            <CuzCell>{rowData.modelNumber}</CuzCell>
          }
        </span>
        )
      }
    },
    checkInUser:{
      sorting: false,
      title: "Last User",
      field: "checkInUser",
      cellStyle: {
        minWidth: 150,
        maxWidth: 150,
      },
      render: rowData => {
        return (<span>
          {rowData?.checkInUser?.length > 10 ?
            <Tooltip title={rowData.checkInUser} arrow placement="bottom-start">
              <CuzCell>{rowData.checkInUser}</CuzCell>
            </Tooltip>
            :
            <CuzCell>{rowData.checkInUser}</CuzCell>
          }
        </span>
        )
      }
    },
    userId:{
      sorting: false,
      title: "Checked Out By",
      field: "userId",
      cellStyle: {
        minWidth: 150,
        maxWidth: 150,
      },
      render: rowData => {
        return (<span>
          {rowData?.userId?.length > 10 ?
            <Tooltip title={rowData.userId} arrow placement="bottom-start">
              <CuzCell>{rowData.userId}</CuzCell>
            </Tooltip>
            :
            <CuzCell>{rowData.userId}</CuzCell>
          }
        </span>
        )
      }
    },
    gpsLocation:{
      sorting: false,
      title: "Map View",
      field: "gpsLocation",
      disableClick: true,
      hidden: !globalAppSettings?.enableGPSLocation,
      cellStyle: {
        minWidth: 150,
        maxWidth: 150,
      },
      render: rowData => {
        return (
        <span onClick={()=>launchMap(rowData.gpsLocation,t('gps.coordinate_error'))}>
          <CuzCell>
            {rowData.gpsLocation !== undefined?<LocationIcon style={{color: '#0073E6',cursor:'pointer' }} />: ''}
          </CuzCell>
        </span>
        )
      }
    },
    apFriendlyName:{
      sorting: false,
      title: "Location",
      field: "apFriendlyName",
      cellStyle: {
        minWidth: 150,
        maxWidth: 150,
      },
      render: rowData => {
        return (<span>
          {rowData?.friendlyName?.length > 10 ?
            <Tooltip title={rowData.apFriendlyName} arrow placement="bottom-start">
              <CuzCell>{rowData.apFriendlyName ? rowData.apFriendlyName : rowData.apMacAddress}</CuzCell>
            </Tooltip>
            :
            <CuzCell>{rowData.apFriendlyName ? rowData.apFriendlyName : rowData.apMacAddress}</CuzCell>
          }
        </span>
        )
      }
    },
    deviceStateName: {
      sorting: false,
      title: "Status",
      field: "deviceStateName",
      cellStyle: {
        minWidth: 150,
        maxWidth: 150,
      },
      render: rowData => {
        return (
          <span>
            <CuzCell style={{ color: `${deviceStatusColorMapper[rowData.deviceStateName]}`, fontWeight: "bold" }}>
              {rowData.deviceStateName}
            </CuzCell>
          </span>
        )
      }
    },
    connectionState:{
      sorting: false,
      title: "Connection",
      field: "connectionState",
      cellStyle: {
        minWidth: 200,
        maxWidth: 200,
      },
    },
    batteryLevel:{
      sorting: false,
      title: "Battery %",
      field: "batteryLevel",
      cellStyle: {
        minWidth: 120,
        maxWidth: 120,
      },
    },
    isCharging:{
      sorting: false,
      title: "Charging",
      field: "isCharging",
      cellStyle: {
        minWidth: 150,
        maxWidth: 150,
      },
    },
    siteName:{
      sorting: false,
      title: "Site",
      field: "siteName",
      cellStyle: {
        minWidth: 150,
        maxWidth: 150,
      },
      render: rowData => {
        return (<span>
          {rowData?.friendlyName?.length > 10 ?
            <Tooltip title={rowData.siteName} arrow placement="bottom-start">
              <CuzCell>{rowData.siteName}</CuzCell>
            </Tooltip>
            :
            <CuzCell>{rowData.siteName}</CuzCell>
          }
        </span>
        )
      }
    },
    checkedOutAt:{
        sorting: !disableSorting,
        customSort: (a, b) => b-a,
        title: t('checkedOutAt'),
        field: "checkedOutAt",
        hidden: !globalAppSettings?.checkin,
        cellStyle: {
          minWidth: 300,
          maxWidth: 300,
        },
        render: rowData => {
          return (
            <span>
            {rowData.checkedOutAt ? convertUtcToTimeZone(rowData.checkedOutAt,rowData.siteTimeZone) : null}
            </span>
          )
        }
    },
    checkedInAt:{
      sorting: false,
      title: t('lastCheckIn'),
      field: "checkedInAt",
      hidden: !globalAppSettings?.checkin,
      cellStyle: {
        minWidth: 300,
        maxWidth: 300,
      }
    },
    reportedAt:{
      sorting: !disableSorting,
      customSort: (a, b) => b-a,
      title: t('lastReported'),
      field: "reportedAt",
      cellStyle: {
        minWidth: 300,
        maxWidth: 300,
      },
      render: rowData => {
        return (
          <span>
          {convertUtcToTimeZone(rowData.reportedAt,rowData.siteTimeZone)}
          </span>
        )
      }
    },
    // if dlr feature is enable then only showing below columns
    enrolmentStatus: {
      sorting: false,
      title: "Enrollment Staus",
      field: "dlrEnrolStatus",
      hidden: !showDLR,
      cellStyle: {
        minWidth: 300,
        maxWidth: 300,
      },
      render: rowData => {
        let dlrStatus='';
        if(typeof undefined != typeof rowData.dlrEnrolStatus){
          dlrStatus=DLR_MACHINE_LEARNING.DLR_ENROLL_STATUS[rowData.dlrEnrolStatus]
        }
        else{
          dlrStatus="-"
        }
        return (
          <span>
            {dlrStatus}
          </span>
        )
      }
    },
    enrolmentDate: {
      sorting: false,
      title: "Enrollment Date",
      field: "lastEnrolOn",
      hidden: !showDLR,
      cellStyle: {
        minWidth: 300,
        maxWidth: 300,
      },
      render: rowData => {
        if(rowData.lastEnrolOn && rowData.dlrEnrolStatus && rowData.dlrEnrolStatus == DLR_MACHINE_LEARNING.ENROLL_STATUS_VALUES.ENROLLED){
        return (
          <span>
            {convertUtcToTimeZone(rowData.lastEnrolOn,rowData.siteTimeZone)}
          </span>
        )
        }
        else{
          return(
            <span>-</span>
          )
        }
      }
    },
    zdsStatus: {
      sorting: false,
      title: "Zebra Data Services Status",
      field: "dlrIssue",
      hidden: !showDLR,
      cellStyle: {
        minWidth: 300,
        maxWidth: 300,
      },
      render: rowData => {
        let dlrIssue='';
        if(typeof undefined != typeof rowData.dlrIssue){
          dlrIssue=DLR_MACHINE_LEARNING.DLR_ISSUE[rowData.dlrIssue]           // ZDS Status/Issue
        }
        else{
          dlrIssue="-"
        }
        return (
          <span>
            {dlrIssue}
          </span>
          )
        }
    },
    accessory: {
      title: (<>Accessory &nbsp; 
        <TooltipMat 
          title={(<><p style={{
                    color:"#6EF0B8",
                    fontSize:16,
                    fontWeight:400
                  }}>
                    Green: Connected
                  </p>
                  <p style={{
                    color:"#FF8692",
                    fontSize:16,
                    fontWeight:400
                  }}>
                    Red: Disconnected
                  </p>
                  <p style={{
                    color:"#FFFFFF",
                    fontSize:16,
                    fontWeight:400
                  }}>Black: Last Connected
                  </p></>)
                }
          data={(<HelpOutlineIcon className="device-helpoutline-icon" style={{fontSize:16}} />)} 
        /> 
    </>),
      field: "accessory",
      cellStyle: {
        minWidth: 250,
        maxWidth: 250
      },
      hidden: !globalAppSettings?.enableBTScannerTracking,//globalAppSettings?.enableBTScannerTracking,
      render: rowData => {
        return (<span>
          { //styleName: Standard/Body/Medium;
            rowData?.btscanner?.scannerID?.length > 15 ?
            <Tooltip title={rowData?.btscanner.scannerID} arrow placement="bottom-start">
              <CuzCell>
                <p style={{ padding:0,margin:0,color: `${accessoryStateColorMap[rowData?.btscanner?.state?rowData?.btscanner?.state:0]}`}}>{rowData?.btscanner.scannerID.substring(0,15)}...</p>
              </CuzCell>
            </Tooltip>
            :
            <CuzCell>
              <p style={{ padding:0,margin:0,colorcolor: `${accessoryStateColorMap[rowData?.btscanner?.state?rowData?.btscanner?.state:0]}`}}>
                {rowData?.btscanner?.scannerID}
              </p>
            </CuzCell>
          }
        </span>
        )
      }
    }
  }

  const checkBox = {
    title: (
      <Checkbox
      checked={pageSize && data && data.length != 0 && ((pageSize == selectedData.length) || (data.length == selectedData.length))}
      disabled={data === null || data === undefined || data.length === 0}
      onClick={onSelectAllChecked}
      onChange={(val) => { }}
      color="primary"
      name="deviceRow" />
      ),
    sorting: false,
    field: "friendlyName",
    cellStyle: {
      minWidth: 70,
      maxWidth: 70,
    },
    render: rowData => {
      return (
        <Checkbox
          checked={rowData?.checked ? true : false}
          onClick={(e) => {
            let selecedData = selectedData
            const sortedData = selecedData.filter((x) => x.id == rowData.id)
            if (sortedData.length != 0) {
              let rowIndex = selecedData.indexOf(sortedData[0])
              selecedData.splice(rowIndex, 1);
              rowData.checked = false;
              setselectAll(false)
            } else {
              rowData.checked = true;
              selecedData.push(rowData);
            }

            setSelectedData(selecedData);
            onRwoSelected(!_ds);
            e.stopPropagation();
          }}
          value={rowData.checked}
          onChange={(val) => {

          }}
          color="primary"
          name="deviceRow" />
      )
    }
  }

  const finalColumns = [];
  columnsData?.map((item) => {
    if(!colJson[item].hidden){
      let currentColumn = colJson[item];
      if(sortingData.length && sortingData[0] == currentColumn.field){
        if(columnPreferenceOpen){
          delete currentColumn["defaultSort"]
        }
        else{
          currentColumn["defaultSort"] = sortingData[1]
        }
      }
      finalColumns.push({...currentColumn});
    }
  });

  if(finalColumns.length > 0 )  finalColumns.unshift(checkBox);



  return (
    <PageWrapper
      style={{
        cursor: isLoading ? "wait" : "default",
        opacity: isLoading ? "0.4" : "1",
        position: "relative",
      }}
    >
      {isLoading && (
        <div style={{ position: "absolute", top: "50%", left: "50%" }}>
          <CircularProgress />
        </div>
      )}
  
      <RearrangeDashBoardColumnModel
        show={columnPreferenceOpen}
        close={closeDialog}
        updateColumns={setColumnsData}
        excludeColumn={excludeColumnArray}
        preferencePage={"DEVICE_DASHBOARD"}
      />

      {/* filter dropdown */}
      {
        sortAndFilterFlag && 
            <FilterMenu
              anchorRef={filterAnchorRef}
              openFilter={openFilterMenu}
              applyFilter={applyFilter}
              filters={filterItems}
              excludeFilterItems={excludeFilterItems}
              actions={filterActions}
              filterDbName="DeviceDash"
              updateSelectedFilter={updateSelectedFilter}
            />
      }

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '100%' }}>
      {finalColumns !== undefined && finalColumns.length !== 0 ?  
            <ActionDropDown
              label={t('action')}
              disable={false}
              selectedRows={selectedData.length}
              options={[

                { label: 'Edit', disable: false, header: true },
                {
                  label: 'Site', key: 'edit_site', disable: isManager ? true : (globalAppSettings.deviceRegistrationType === 1 || globalAppSettings.deviceRegistrationType === 2) ? true : false, action: 'e',
                  hide: isManager
                },
                {
                  label: 'Device Name', key: 'edit_device', disable: (selectedData.length > 1) ||
                    (isManager ? globalAppSettings?.userRoleSettings?.manager?.Devices && globalAppSettings?.userRoleSettings?.manager?.Devices[0] === 'update' ? false : true : !enableModDelete), action: 'e', hide: false
                },
                { label: 'Delete Device', key: 'delete', disable: isManager, action: 'd', hide: isManager },

                { label: 'Tracking', disable: false, header: true },
            { label: "Refresh Current Device's Location", disable: false, action: 't'},
                { label: 'Mark Device for finding', disable: false, action: 't' },
                { label: 'Mark device as InService', disable: false, action: 't' },
                { label: 'Cannot Find', disable: false, action: 't' },
            { label: 'Play Sound', disable: false, action: 't'},
                { label: 'Add Notes', disable: false, action: 't' },
                { label: 'Recommission Device', disable: false, action: 't' },
                { label: 'Decommission Device', disable: false, action: 't' }
          ]
          }
              GetChangeAction={onActionValueChange}
              clrSelectedRows={() => {
                let rowData = data
                rowData.forEach(element => {
                  element.checked = false
                });
                setData(rowData)
                setselectAll(!selectAll)
                setSelectedData([])
                onRwoSelected(!_ds)
              }}
        /> :""}


        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ margin: '0 10px' }}>{t('lastUpdated')}: {getFormatedDate(lastUpdated)}</div>

          { /* If there are no menu items,no need to show the Manage button itself */}
          {
            (isManager &&
              globalAppSettings?.userRoleSettings?.manager?.Devices && globalAppSettings?.userRoleSettings?.manager?.Devices[0] === 'update') || !isManager ?
              <DropdownActions
                label={t('csvModal.Manage')}
                opts={menus}
                onChangeAction={onChangeManageBtn} /> : null
          }
  
          <div> 
          <Button
                variant ="outlined"
                
            onClick={openDialog}
                
                style={{textTransform: 'none' ,color:"#0073E6" ,borderColor:"#0073E6", backgroundColor: 'transparent'}}
          >
                {t('csvModal.EditColumns')}
                <ViewWeekIcon fontSize="small" style={{marginLeft:"5px"}}/>
          </Button>
        </div>
            {
              sortAndFilterFlag && 
              <div>
                <Button
                  ref={filterAnchorRef}
                  aria-controls={openFilterMenu ? 'menu-list-grow' : undefined}
                  aria-haspopup="true"
                  onClick={()=> setOpenFilterMenu(prevOpen => !prevOpen) }
                  variant={ appliedFilterCount > 0 ? "contained" :"outlined"}
                  color="primary"
                  style={{ 
                      textTransform: "none", 
                      marginLeft: "12px", 
                      marginRight: "5px", 
                      color: appliedFilterCount > 0 ? "#FFFFFF" :"#0073E6",
                      borderColor: appliedFilterCount > 0 ? "#FFFFFF" :"#0073E6",
                      backgroundColor: appliedFilterCount > 0 ? "#0073E6" : "transparent",
                    }}
                >
                  <span>{appliedFilterCount > 0 ? `${appliedFilterCount} Filters Selected` : "Filter"}</span> 
                  <FilterListIcon style={{ marginLeft: "8px" }}/>
                </Button>
      </div>
            }
  
          <DevicesToolbar
            hidePagination={hidePagination}
            inputSearchPlaceholder={" "}
            searchText={searchText}
            onSearch={(searchVal, searchOptVal) => {
              if (searchVal != "") {
                setSearchText(searchVal);
                searchValueFromDB(searchVal, searchOptVal);
              }
            }}
            onClear={(searchVal) => {

              setdbSeacrh(['', ''])
              setSearchText("");
              props.devSearchField('','')
            }}
            multiSearchOpts={[
              { name: "Device Model", value: "modelNumber" },
              { name: "Serial #", value: "serialNumber" },
              { name: "Device name", value: "friendlyName", },
              { name: "Checked Out By", value: "userId" },
              { name: "Location", value: "apFriendlyName" },
            ]}
            onRefreshClick={() => refreshPageClicked()}
          />
        </div>

      </div>

      <div>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={5000}
          onClose={() => {
            setSnackbarOpen(false);
          }
          }
        >

          <SnackbarContent error={serverResponse.current.status ? false : true}>
            {serverResponse.current.msg}
          </SnackbarContent>
        </Snackbar>
      </div>
      <MainContent>
      {finalColumns.length === 0 ? <div style={{textAlign:'center',paddingTop:"2%",paddingBottom:"2%"}}>{t('messages.error.err52')}</div>:""}
        <MaterialTable
          isLoading={isLoading}
          theme={theme}
          title=""
          columns={finalColumns}

          data={data}
          options={{
            paginationType: "stepped",
            search: false,
            minBodyHeight: "250px",
            maxBodyHeight: "400px",
            selection: false,
            paging: itemCount > pageSize ? true : false,
            pageSize: pageSize,
            cspNonce: window.NONCE_ID,
            draggable: false,
            showEmptyDataSourceMessage: !isLoading,
            thirdSortClick: false
            // tableLayout: "fixed"
          }}
          onRowClick={onClickTableRow}
          onOrderChange={ handleSorting }
          icons={tableIcons}
          onSelectionChange={(rows) => setSelectedData(rows)}
          onChangeRowsPerPage={(val) => {
            setPageSize(val);
            // getData(val);
          }}
          components={{
            Pagination: (props) => (
              <Pagination
                hidePagination={hidePagination}
                {...props}
                itemCount={itemCount}
                currentPage={currentPage}
                onNextClicked={next}
                onPrevClicked={prev}
              />
            ),
            Toolbar: (props) => (
              <div style={{ height: "0px", }}></div>
            ),
          }}
          localization={{
            body: {
              emptyDataSourceMessage: (isLoading == false) && (data && data.length==0)?t('messages.error.err26'):"",
            },
          }}
        />
      </MainContent>
      <AddNoteModal
        modalRef={addUserModalRef}
        getAddedNote={getAddedNote}
        clearNote={clearNote}
        noteValue={note}
      />
      <DevicesManageAMDModal
        modalRef={DevicesManageAMDModalRef}
        importType={manageBtnValue}
        onContinue={continueBtnClicked}
        isLoadingCsv={isLoadingCsv}
      />
      <CsvCompModal
        modalRef={CsvCompModalRef}
        importType={manageBtnValue}
        ConfigData={DevicesConfigData}
        refreshPage={refreshPageClicked}
        // sitesData={sitesData}
        // devicesData={devicesData}
        // hasUpdatedTime={hasUpdatedTime}
        // isLoadingCsv={isLoadingCsv}
        onCancelHit={onCancelHit}
      />
      <AddDevicesPopUp
        modalRef={AddDevicesModalRef}
        popUpTrigger={AddModiDeletePopUpTrigger}
      />
      <ConfirmationModal
        title={confirmPopData.title}
        body={confirmPopData.msg}
        modalRef={confirmationModalRef}
        btnData={confirmPopData.btnData}
        topMsg={confirmPopData.topMsg}
        needcheck={confirmPopData.needcheck}
        checktext={confirmPopData.checktext}
        fromConfirmationPopup={fromConfirmationPopup}
      />
      <ModifyDevicesPopUp
        modalRef={ModifyDevicesModalRef}
        PopupData={modifyDevicesPopupData}
        popUpTrigger={AddModiDeletePopUpTrigger}
      />
    </PageWrapper>
  );
}